var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMpAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0189 22.3519C15.0189 23.2629 15.7462 24 16.6451 24C17.5441 24 18.2714 23.2629 18.2714 22.3519H15.0189ZM16.6451 9.92048C18.9006 9.92048 20.7312 11.7757 20.7312 14.0615V19.859H12.5591V14.0615C12.5591 11.7757 14.3896 9.92048 16.6451 9.92048ZM16.6451 6.19354C15.9669 6.19354 15.4193 6.74844 15.4193 7.43585V8.40486C12.8533 8.96804 10.9247 11.287 10.9247 14.0615V19.0308L9.29028 20.6872V21.5154H24V20.6872L22.3656 19.0308V14.0615C22.3656 11.287 20.437 8.96804 17.8709 8.40486V7.43585C17.8709 6.74844 17.3234 6.19354 16.6451 6.19354Z",
    fill: "#323232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8129 0H2.09033C0.940647 0 0 0.958066 0 2.12904V14.9033C0 16.0742 0.940647 17.0323 2.09033 17.0323H9.78496V14.9033H2.09033V4.25807L10.4516 9.58066L18.8129 4.25807V7.45163L20.9033 8.229V2.12904C20.9033 0.958066 19.9626 0 18.8129 0ZM10.4516 7.45163L2.09033 2.12904H18.8129L10.4516 7.45163Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMpAlert);
export default __webpack_public_path__ + "static/media/MP_alert.648f5e9b4232744b0b6f38c52bff9d07.svg";
export { ForwardRef as ReactComponent };